import {
  GET_FOLLOWUP,
  FOLLOWUP_ERROR,
  GETFOLLOWUP_DETAIL,
  UPDATEFOLLOWUP,
  FOLLOWUP_LIST,
  GET_LEAD_TYPE,
  GET_SITEVISIT_TYPE,
  GET_BOOKING_TYPE,
  GET_REGISTRAION_TYPE,
  UPDATE_STATUS,
  ADD_FOLLOWUP,
  SCHEDULED_FOLLOWUP_ACTIVITY,
  MARK_SCHEDULED_FOLLOWUP
} from "../types";
import followUpService from "reduxStore/service/followUpService ";
import strings from "translate/language";
import { errorToast, unAuthorizedError, successToast } from "utils/httpClient";

export const getFollowUp = (item) => async (dispatch) => {
  try {
    const res = await followUpService.getFollowUp(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_FOLLOWUP,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const followupList = (item) => async (dispatch) => {
  try {
    const res = await followUpService.followupList(item);
    if (res.data.status === 200) {
      dispatch({
        type: FOLLOWUP_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: FOLLOWUP_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getLeadType = () => async (dispatch) => {
  try {
    const res = await followUpService.followupList({ type: 1 });
    if (res.data.status === 200) {
      dispatch({
        type: GET_LEAD_TYPE,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_LEAD_TYPE,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getSiteVisitType = () => async (dispatch) => {
  try {
    const res = await followUpService.followupList({ type: 2 });
    if (res.data.status === 200) {
      dispatch({
        type: GET_SITEVISIT_TYPE,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_SITEVISIT_TYPE,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getBookingType = () => async (dispatch) => {
  try {
    const res = await followUpService.followupList({ type: 3 });
    if (res.data.status === 200) {
      dispatch({
        type: GET_BOOKING_TYPE,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_BOOKING_TYPE,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getRegistrationType = () => async (dispatch) => {
  try {
    const res = await followUpService.followupList({ type: 4 });
    if (res.data.status === 200) {
      dispatch({
        type: GET_REGISTRAION_TYPE,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
    dispatch({
      type: GET_REGISTRAION_TYPE,
      payload: [],
    });
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getFollowUpDetail = (item) => async (dispatch) => {
  try {
    const res = await followUpService.getFollowupDetail(item);
    if (res.data.status === 200) {
      dispatch({
        type: GETFOLLOWUP_DETAIL,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const updateFollowUp = (item) => async (dispatch) => {
  try {
    const res = await followUpService.updateFollowUp(item);
    if (res.data.status === 200) {
      dispatch({
        type: UPDATEFOLLOWUP,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
// export const addFollowUp = (item) => async (dispatch) => {
//   try {
//     const res = await followUpService.addFollowUp(item);
//     if (res.data.status === 200) {
//       dispatch({
//         type: UPDATE_STATUS,
//         payload: res.data,
//       });
//       successToast(res.data.message);
//     } else {
//       errorToast(res.data.message);
//     }
//   } catch (e) {
//     const { response = strings.initialError } = e;
//     unAuthorizedError(response.data);
//   }
// };
export const addFollowUp = (item) => async (dispatch) => {
  try {
    const res = await followUpService.addFollowUp(item);
    if (res.data.status === 200) {
      dispatch({
        type: ADD_FOLLOWUP,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      dispatch({
        type: ADD_FOLLOWUP,
        payload: [],
      });
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getScheduledFollowupList = (item) => async (dispatch) => {
  try {
    const res = await followUpService.getScheduledFollowupList(item);
    if (res.data.status === 200) {
      dispatch({
        type: SCHEDULED_FOLLOWUP_ACTIVITY,
        payload: res.data,
      });
    } else {
      dispatch({
        type: SCHEDULED_FOLLOWUP_ACTIVITY,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getMarkScheduledFollowup = (item) => async (dispatch) => {
  try {
    const res = await followUpService.getMarkScheduledFollowup(item);
    if (res.data.status === 200) {
      dispatch({
        type: MARK_SCHEDULED_FOLLOWUP,
        payload: res.data,
      });
    } else {
      dispatch({
        type: MARK_SCHEDULED_FOLLOWUP,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};